import $ from 'jquery';

$(() => {
  const nav = document.querySelector('.pb-nav');
  const navMargin = nav.offsetHeight - 1;
  // accounts for the sticky content of logo and title which for some reason
  // doesn't get computed in the offset height
  const topMargin = nav.offsetHeight + 69;
  const bottomMargin = window.innerHeight - topMargin - 1;
  const guideSections = document.querySelectorAll('.pb-section');
  const navObserver = new IntersectionObserver(
    ([e]) => {
      e.target.classList.toggle('sticky', e.intersectionRatio < 1);
    },
    {
      threshold: [1],
    },
  );

  navObserver.observe(nav);

  const sectionOptions = {
    rootMargin: `-${topMargin}px 0px -${bottomMargin}px 0px`,
  };
  const changeNav = (entries) => {
    entries.forEach((entry) => {
      // verify the element is intersecting within the root margin set above
      if (entry.isIntersecting) {
        // remove old active class
        document.querySelector('.active-nav').classList.remove('active-nav');
        // get id of the intersecting section
        const id = entry.target.getAttribute('id');
        // find matching link & add appropriate class
        document
          .querySelector(`[data-section='${id}']`)
          .classList.add('active-nav');
      }
    });
  };

  const sectionObserver = new IntersectionObserver(changeNav, sectionOptions);

  // target the elements to be observed
  guideSections.forEach((section) => {
    sectionObserver.observe(section);
  });

  function scrollToSection(sectionName) {
    $('html, body').animate(
      {
        scrollTop: $(`#${sectionName}`).offset().top - navMargin,
      },
      'slow',
    );
    // collapse mobile menu after selecting nav
    $('.pb-mobile-nav').removeClass('is-visible');
    $('.usa-overlay').removeClass('is-visible');
  }

  $('.pb-top-link').on('click', () => {
    scrollToSection('infrastructure-playbook');
  });

  $('.pb-nav-link').on('click', function () {
    const selectedSectionId = $(this).data('section');
    const selectedSection = $(`#${selectedSectionId}`);
    scrollToSection(selectedSectionId);
    selectedSection.trigger('focus');
    window.location.hash = $(this).data('hash');
  });

  $('.pb-mobile-nav-link').on('click', function () {
    const selectedSectionId = $(this).data('section');
    const selectedSection = $(`#${selectedSectionId}`);

    scrollToSection(selectedSectionId);
    selectedSection.trigger('focus');
    // this body class appears with the mobile nav and makes the user unable
    // to scroll and has to be removed once a mobile nav item has been clicked
    $(document.body).removeClass('usa-js-mobile-nav--active');
  });

  $('.usa-menu-btn').on('click', () => {
    $('.pb-mobile-nav').addClass('is-visible');
    $('.usa-overlay').addClass('is-visible');
  });

  function setActiveTab(element, listId) {
    const sectionTabs = $(`.pb-section-link[data-tablist='${listId}']`);
    const panelTabs = $(`.pb-panel[data-tablist='${listId}']`);
    sectionTabs.attr('aria-selected', 'false');
    $(element).attr('aria-selected', 'true');
    const tabPan = $(element).attr('aria-controls');
    const tabPanId = $(`#${tabPan}`);
    panelTabs.attr('aria-hidden', 'true');
    tabPanId.attr('aria-hidden', 'false');
  }

  $('.pb-section-link').on('click', function (event) {
    const listId = $(this).data('tablist');
    setActiveTab(event.target, listId);
  });

  const selectedSection = window.location.hash;
  const sectionLinks = [
    '#introduction',
    '#planning',
    '#engagement',
    '#siting',
    '#funding',
    '#policies',
    '#regulations',
    '#procurement',
    '#revenue',
  ];

  if (sectionLinks.includes(selectedSection)) {
    $(`[data-hash="${selectedSection}"]`).trigger('click');
  }
});

function displayResources(module, checkValue, checkValueChecked) {
  const moduleCards = document.querySelectorAll(`[data-category=${module}]`);
  const moduleChecks = document.querySelectorAll(`[data-module=${module}]`);
  const moduleAllCheck = document.querySelector(
    `input[type=checkbox][data-module=${module}]`,
  );
  const checkedArray = [];

  // if all is checked, then the rest of the checkboxes need to be cleared and all cards displayed
  if (checkValue === 'all' && checkValueChecked === true) {
    moduleChecks.forEach((checkboxEl) => {
      if (checkboxEl.checked && checkboxEl.value !== 'all') {
        checkboxEl.checked = false;
      }
    });

    moduleCards.forEach((card) => {
      card.style.display = 'block';
    });
    return;
  }
  // if a checkbox other than all is checked then the all checkbox needs to be un-checked
  moduleChecks.forEach((checkboxEl) => {
    if (checkboxEl.checked && checkboxEl.value !== 'all') {
      checkedArray.push(checkboxEl.value);
      moduleAllCheck.checked = false;
    }
  });
  moduleCards.forEach((card) => {
    card.style.display = 'none';
    checkedArray.forEach((checkBoxId) => {
      if (card.dataset.resources.includes(checkBoxId)) {
        card.style.display = 'block';
      }
    });
  });
}

const resourceChecks = document.querySelectorAll('input[type=checkbox]');
resourceChecks.forEach((checkboxEl) => checkboxEl.addEventListener('change', function () {
  const module = this.getAttribute('data-module');
  displayResources(module, this.value, this.checked);
}));
